/** Chats admin viewer -- root layout: paginated conversation list, the open thread, participants slide-over. Auth / G4
 *  gating happens upstream in init.tsx. Theme tokens are scoped to .chats-viewer-root so the bundle is self-styled. */

import { type CSSProperties } from 'react';
import { FULL_HEIGHT_STYLE } from '@federa/const/style-size-presets';
import { THEME_CSS } from './chats-viewer-tokens.ts';
import { useChatsViewer } from './use-chats-viewer.ts';
import { ConversationList } from './ConversationList.tsx';
import { MessageThread } from './MessageThread.tsx';
import { ParticipantsPanel } from './ParticipantsPanel.tsx';

// The tab shell in init.tsx pins the MFE to the viewport height (100dvh column; it owns the overflow because the admin shell's <main> is `overflow-y-auto` and `height:100%` won't resolve through the unbounded MFE container chain). This viewer fills the tab pane (height:100%) and scrolls the conversation list INTERNALLY, so <main> has nothing left to scroll.
// NO `fontFamily` KEY (DL-1.13, 2026-08-20). This shell used to spell a system font stack -- the one hand-rolled stack
// left in the rendering tier -- which matched none of the four SDL families and rendered the viewer in a different face
// from every surface around it. The cure is DELETION rather than a token read: chats is injectable-only (no index.html,
// no globals.css, no standalone vite arm), so it has no sheet of its own to resolve a `var(--font-family-sans)`
// against; it mounts inside the admin shell, whose base.css already publishes that family on `body`. Removing the key
// lets the host's cascade reach the viewer, which is what every other embedded surface relies on.
const shell: CSSProperties = {
	display: 'flex',
	...FULL_HEIGHT_STYLE,
	minHeight: 0,
	flex: 1,
	overflow: 'hidden',
};

export function App() {
	const viewer = useChatsViewer();
	return (
		<>
			<style>{THEME_CSS}</style>
			<div className="chats-viewer-root" style={shell}>
				<ConversationList
					list={viewer.list}
					selectedId={viewer.thread.conversation?.id ?? null}
					onSelect={viewer.openConversation}
					onPageChange={viewer.loadPage}
					onSearch={viewer.search}
				/>
				<MessageThread thread={viewer.thread} onShowParticipants={viewer.showParticipants} />
				<ParticipantsPanel parts={viewer.parts} onClose={viewer.closeParticipants} />
			</div>
		</>
	);
}

export default App;
